import {
  HEX_0C1017,
  HEX_121820,
  HEX_1D2939,
  HEX_273D58,
  HEX_292D38,
  HEX_2D3B4D,
  HEX_3B93EE,
  HEX_3E4B68,
  HEX_477FBA,
  HEX_646A7E,
  HEX_66AAFF,
  HEX_7F869D,
  HEX_ADB5C7,
  HEX_ECF4FF,
  HEX_FFFFFF,
} from '@tanium/colors';
import {
  Border1,
  Border2,
  defineColor,
  Foreground1,
  InputDisabledBorder,
  InputDisabledFill as InputDisabledFillThemeDef,
  InputInvalidBorder,
  Link,
  Text1,
  Text2,
  TextSecondary,
} from '@tanium/react-theme-definition';

export const ContainerFill = defineColor(['transparent', HEX_0C1017]);
export const ContainerBorder = Border2;
export const InvalidBorder = InputInvalidBorder;
export const DisabledBorder = InputDisabledBorder;

export const ControlFill = defineColor([HEX_FFFFFF, HEX_0C1017]);

export const OptionText = Text1;
export const OptionHoverFill = defineColor([HEX_ECF4FF, HEX_273D58]);
export const OptionSelectedText = Foreground1;
export const OptionSelectedFill = defineColor([HEX_477FBA, HEX_477FBA]);
export const OptionDisabledText = defineColor([HEX_ADB5C7, HEX_7F869D]);

export const MenuBorder = Border1;
export const MenuFill = defineColor([HEX_FFFFFF, HEX_1D2939]);

export const MenuListFill = defineColor(['transparent', HEX_121820]);

export const InputFill = defineColor([HEX_FFFFFF, HEX_0C1017]);
export const InputDisabledFill = InputDisabledFillThemeDef;

export const DropdownIcon = defineColor([HEX_477FBA, HEX_66AAFF]);
export const DropdownIconActive = defineColor([HEX_3E4B68, HEX_477FBA]);
export const DropdownIconHover = defineColor([HEX_3B93EE, HEX_477FBA]);
export const DropdownOpenIcon = defineColor([HEX_292D38, HEX_477FBA]);
export const DropdownDisabledIcon = defineColor([HEX_646A7E, HEX_2D3B4D]);

export const ClearIcon = DropdownIcon;
export const ClearIconHover = defineColor([HEX_3B93EE, HEX_477FBA]);
export const ClearIconActive = DropdownIconActive;

export const PlaceholderText = TextSecondary;

export const NoOptionsText = TextSecondary;

export const GroupHeadingText = TextSecondary;

export const LoadingMessage = TextSecondary;

export const SingleValueText = Text2;

export const InputText = Text2;

export const RemainingPillCount = Link;

export const Border = Border2;
export const InputFocus = defineColor([HEX_477FBA, HEX_66AAFF]);
export const InputFocusBoxShadow = `0 0 8px ${HEX_477FBA}`;
